module.exports = __webpack_public_path__ + "static/media/cellphone_screen-service.e0093d1e.png";